<template lang="pug">
section.main
</template>

<script>
import { getData } from '../utils/api'

// import { clone } from '../utils/libs'

import dayjs from 'dayjs'

const redirectUrl = `${process.env.VUE_APP_APP_PROTOCOL}://${process.env.VUE_APP_APP_DOMAIN}/*/`

const page = {
  id: 'redirect',
  title: 'リダイレクト'
}

export default {
  name: page.id,
  data () {
    return {
      app: {
        name: process.env.VUE_APP_NAME
      },
      page: page
    }
  },
  async created () {
    if (this.$auth.isAuthenticated) {
      let accessToken
      if (this.$store.state.accessToken && dayjs(this.$store.state.expireIn).toDate() > new Date()) {
        accessToken = this.$store.state.accessToken
      } else {
        accessToken = await this.$auth.getTokenSilently()
        this.$store.commit('setAccessToken', accessToken)
      }

      await getData(`/mycompanies/`).then((data) => {
        console.log(data)
        if (data && data.length > 0) {
          window.location.href = redirectUrl.replace('*', data[0].directory)
          // this.$store.state.directory
        } else {
          this.msgBoxError('正常にログインできませんでした')
        }
      }).catch((err) => {
        console.log(err)
        this.msgBoxError('正常にログインできませんでした')
      })
    } else {
      this.$auth.loginWithRedirect()
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
